module.exports = __webpack_public_path__ + "29cb4202bba75fa89561239716319b20.png";